import { useNavigate } from "react-router-dom";

export default function TodaysAlertsBar() {
  const navigate = useNavigate();

  return (
    <div className="bg-white rounded-xl border border-gray-200 p-4">
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-sm font-semibold text-gray-900">Today&apos;s Alerts</h3>
        <button className="text-xs text-indigo-600 hover:text-indigo-700 font-medium whitespace-nowrap">
          View All
        </button>
      </div>

      <div className="flex gap-3 flex-wrap">
        {/* Pill 1 — Stale Leads */}
        <button
          onClick={() => navigate("/reports")}
          className="bg-red-50 border border-red-200 rounded-xl px-4 py-2 cursor-pointer hover:bg-red-100 transition-colors text-left"
        >
          <div className="flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-red-500 flex-shrink-0" />
            <div>
              <span className="font-medium text-red-700 text-sm">23 stale leads</span>
              <span className="block text-xs text-red-500">needs follow-up</span>
            </div>
          </div>
        </button>

        {/* Pill 2 — Uncontacted Leads */}
        <button
          onClick={() => navigate("/leads")}
          className="bg-amber-50 border border-amber-200 rounded-xl px-4 py-2 cursor-pointer hover:bg-amber-100 transition-colors text-left"
        >
          <div className="flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-amber-500 flex-shrink-0" />
            <div>
              <span className="font-medium text-amber-700 text-sm">6 uncontacted leads</span>
              <span className="block text-xs text-amber-500">waiting more than 2 hours</span>
            </div>
          </div>
        </button>

        {/* Pill 3 — Site Visits */}
        <button
          onClick={() => navigate("/calls")}
          className="bg-indigo-50 border border-indigo-200 rounded-xl px-4 py-2 cursor-pointer hover:bg-indigo-100 transition-colors text-left"
        >
          <div className="flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-indigo-500 flex-shrink-0" />
            <div>
              <span className="font-medium text-indigo-700 text-sm">3 site visits today</span>
              <span className="block text-xs text-indigo-500">scheduled and confirmed</span>
            </div>
          </div>
        </button>
      </div>
    </div>
  );
}